import type { McpOAuthClientInfo } from '@dawn/feature-config';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { mcpOAuthApi } from '@/lib/api';

import { queryKeys } from './query-keys';

/**
 * GET /mcp/oauth/client — who is asking for access and where the browser will
 * return. A 4xx means the request itself is invalid, so it is not retried.
 */
export function useMcpOAuthClientQuery(
  params: Record<string, string>
): UseQueryResult<McpOAuthClientInfo> {
  return useQuery({
    queryKey: queryKeys.mcpOAuth.client(params),
    queryFn: ({ signal }) => mcpOAuthApi.client(params, signal),
    retry: false,
    staleTime: Infinity,
  });
}
